import * as Immutable from "immutable";
import GetPositionForNewWidget from "views/logic/views/GetPositionForNewWidget";
export const ConcatPositions = (newPositions, curPositions) => {
  let rowIncrement = 0;
  const newUpdatedPositions = newPositions.map((initialPosition) => {
    const defaultHeight = initialPosition.height;
    const row = rowIncrement + initialPosition.row;
    const widgetPosition = initialPosition.toBuilder().row(row).build();
    rowIncrement += defaultHeight;
    return widgetPosition;
  }).toMap();
  const curUpdatedPositions = curPositions.map((initialPosition) => {
    const row = rowIncrement + initialPosition.row;
    return initialPosition.toBuilder().row(row).build();
  }).toMap();
  return newUpdatedPositions.merge(curUpdatedPositions);
};
export default (widgetPositions, widgets, height = void 0, width = void 0) => {
  const widgetsWithoutPosition = widgets.filter((widget) => !widgetPositions.has(widget.id));
  const newPositions = Immutable.Map(
    widgetsWithoutPosition.map((widget) => [
      widget.id,
      GetPositionForNewWidget(widget, widgetPositions, height, width)
    ])
  );
  return widgetPositions.merge(newPositions);
};
